import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ScrudgService } from '../../base/scrudg/scrudg.service';
import { ScrudgRevisionService } from '../../base/scrudg-revision/scrudg-revision.service';

@Injectable({
    providedIn: 'root'
})

export class ClaimTypeService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "claimtype");
    }
}
